import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import { formatDate } from "@/shared/utils/helperFunctions";
import { Building2, Users, X } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const OrganizationDetailModal = ({ isOpen, onClose, org }) => {
  const navigate = useNavigate();
  const detailData = [
    {
      title: "Team Size",
      value: org?.user_count != null ? `${org.user_count} members` : "—",
      icon: <Users size={16} className="text-gray-500" />,
    },
    {
      title: "Workspace Admin",
      value: org?.admin_name || "Organization Admin",
      email: org?.admin_email || null,
    },
    {
      title: "Created",
      value: org?.created_at ? formatDate(org.created_at) : "—",
    },
  ];
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      width="420px"
      className="p-6 rounded-2xl"
    >
      <div className="flex flex-col gap-5 w-full">
        <div className="flex  justify-between items-center">
          <h1 className="text-gray-800 text-[1rem] leading-7 font-medium">
            Organization Details
          </h1>
          <X
            size={18}
            className="text-gray-500 hover:text-gray-800 cursor-pointer"
            onClick={onClose}
          />
        </div>
        {/* organization details box */}

        <div className="flex flex-col gap-4">
          <div className="py-2 flex gap-2.5 items-start border-b border-gray-200">
            <div className="flex items-center justify-center rounded-full p-3 bg-[#207C971A] w-fit">
              <Building2 className="text-secondary" size={22} />
            </div>
            <div className="flex flex-col">
              <h3 className="text-gray-800 text-[0.89rem] leading-6 font-medium">
                {org?.name || "Organization"}
              </h3>
              <p className="text-gray-500 text-[0.85rem] leading-5 font-normal">
                {org?.user_count != null ? `${org.user_count} members` : ""}
              </p>
            </div>
          </div>

          {/* detail card */}
          <div className="flex flex-col gap-3">
            {detailData?.map((item, idx) => (
              <div key={idx} className="flex flex-col">
                <h6 className="text-gray-500 text-[0.7rem] leading-[18px]">
                  {item.title}
                </h6>
                <p className="text-gray-800 text-[0.85rem] leading-5 font-normal flex items-center gap-1.5">
                  {item.icon && <span>{item.icon}</span>}
                  {item.value}
                </p>
                {item.email && (
                  <p className="text-gray-500 text-[0.7rem] leading-[18px]">
                    {item.email}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* action buttons */}
        <div className="flex gap-3 w-full">
          <SecondaryButton
            title="Close"
            onClick={onClose}
            className="w-full !py-3"
          />
          <PrimaryButton
            children="Request Access"
            onClick={() => navigate("/join-organization/confirm", { state: { org } })}
            startContent={false}
            className="w-full !pt-3 !pb-3"
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default OrganizationDetailModal;
